import { get } from "lodash";
import { initSupplierContactForm } from "./single-helpers";

declare const jQuery: any;
const $ = jQuery;

export function initEventSingle(): void {
    if (!$(document.body).hasClass("single-event")) {
        return;
    }
    initEventSingleExtendedDescription();
    initSupplierContactForm();
    initSupplierContactFormDefaultMessage();
}

function initEventSingleExtendedDescription(): void {
    const $wrap = $(".hs-event-post-single-main");
    const $body = $wrap.find(".extended-description");
    if ($body.length === 0) {
        return;
    }
    const $btnWrap = $wrap.find(".extended-description-button-wrap");
    $btnWrap.find(".read-more").on("click", function (event) {
        $btnWrap.css({ display: "none" });
        $body.addClass("show");
        return false;
    });
    $body.find(".read-less").on("click", function (event) {
        $btnWrap.css({ display: "" });
        $body.removeClass("show");
        return false;
    });
}

function initSupplierContactFormDefaultMessage(): void {
    const postData: any = get(window, "iw.eventPostData");
    if (!postData) {
        console.error("No iw.eventPostData");
        return;
    }
    const title: string = postData.title;
    if (!title) {
        console.error("No iw.eventPostData.title");
        return;
    }
    const date: string = postData.date;
    const msg = `Re event "${title}"` + (date ? ` (${date}): ` : `: `);
    const $msg = $(`#contact-organiser .hs-enquiry-form [name="enquiry"]`);
    $msg.val(msg);
}
